import { createGlobalState } from "react-hooks-global-state";

const { setGlobalState, useGlobalState } = createGlobalState({
  userStatus: false,
});

export { useGlobalState, setGlobalState };
